import { TooltipProps } from "@mui/material";

export const ERROR_TOOLTIP_PROPS: Partial<TooltipProps> = {
    placement: "top",
    arrow: true,
    disableHoverListener: true,
    disableFocusListener: true,
    disableTouchListener: true,
    componentsProps: {
        tooltip: {
            sx: {
                bgcolor: '#82B194',
                fontSize: '13px'
            }
        },
        arrow: {
            sx: {
                color: '#82B194'
            }
        }
    }
};

export const CALENDAR_SX = {
    width: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    padding: 0,
    margin: 0,
    height: 'auto',
    minHeight: 'auto',
    overflow: 'visible',
    fontFamily: '"Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',

    '& .MuiPickersCalendarHeader-root': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 0,
        margin: '0 0 6px 0',
        minHeight: '28px',
    },

    '& .MuiPickersCalendarHeader-labelContainer': {
        margin: 0,
        marginLeft: 'max(0px, calc(7.142857% - 14px))',
        fontSize: '13px',
        fontWeight: 800,
        color: '#13231d',
        fontFamily: '"Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
        textTransform: 'lowercase',
    },
    '& .MuiPickersArrowSwitcher-root': {
        display: 'flex',
        gap: '2px',
        marginRight: 'max(0px, calc(7.142857% - 14px))',
    },
    '& .MuiPickersArrowSwitcher-button': {
        color: '#42524b',
        padding: 0,
        width: '30px !important',
        height: '30px !important',
        minWidth: '30px !important',
        borderRadius: '999px',
        '&:hover': {
            backgroundColor: 'rgba(130, 177, 148, 0.12) !important',
            color: '#13231d'
        },
    },
    '& .MuiDayCalendar-root': {
        border: '1px solid rgba(12, 36, 28, 0.075)',
        borderRadius: '16px',
        padding: '8px 6px 7px',
    },
    '& .MuiDayCalendar-header': {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        justifyContent: 'center',
        justifyItems: 'center',
        textAlign: 'center',
        marginBottom: '7px',
        paddingBottom: '6px',
        borderBottom: '1px solid rgba(12, 36, 28, 0.065)',
    },
    '& .MuiDayCalendar-weekDayLabel': {
        fontFamily: '"Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
        height: 'fit-content',
        fontSize: '9px',
        fontWeight: 800,
        color: '#53615b',
        padding: '3px 0',
        width: '28px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    '& .MuiDayCalendar-weekHeader span': {
        width: 'auto',
        height: 'auto',
        fontSize: '9px',
        fontWeight: 800,
        color: '#53615b',
        padding: '3px 0',
        margin: 0,
        fontFamily: '"Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    },
    '& .MuiDayCalendar-monthContainer': {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        position: 'relative',
        overflow: 'hidden',
    },
    '& .MuiDayCalendar-weekContainer': {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        margin: 0,
        height: '28px',
        alignItems: 'center',
        justifyItems: 'center',
    },
    '& .MuiPickersArrowSwitcher-button svg': {
        width: '18px',
        height: 'auto',
        fontSize: '18px',
    },

    '& .MuiPickersDay-root': {
        margin: 0,
        fontSize: '11px',
        fontWeight: 600,
        color: '#5b6862 !important',
        borderRadius: '999px !important',
        width: '28px !important',
        height: '28px !important',
        minWidth: '28px !important',
        fontFamily: '"Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
        border: 'none',
        backgroundColor: 'transparent',
        transition: 'background .18s ease, box-shadow .18s ease, transform .18s ease',

        '&:hover': {
            backgroundColor: 'rgba(130, 177, 148, 0.12) !important',
        },

        '&.MuiPickersDay-dayOutsideMonth': {
            color: '#b0b7b3 !important',
            fontWeight: 500,
            pointerEvents: 'none',
        },

        '&.Mui-selected': {
            boxShadow: 'none !important',
            backgroundColor: '#82B194 !important',
            color: 'white !important',
            fontWeight: 800,
            borderRadius: '999px !important',
            '&:hover': { backgroundColor: '#739F84 !important' },
        },
        '&.MuiPickersDay-today': {
            backgroundColor: 'transparent !important',
            border: 'none !important',
            color: '#D6A640 !important',
            fontWeight: 800,
            '&.Mui-selected': {
                backgroundColor: '#82B194 !important',
                color: 'white !important',
            },
        },
        '&.available-day:not(.Mui-selected)': {
            boxShadow: 'inset 0 0 0 1.5px #82B194 !important',
            backgroundColor: '#EEF5F0 !important',
            color: '#32483e !important',
            borderRadius: '999px !important',
            '&:hover': {
                backgroundColor: '#E3EFE7 !important',
            },
            '&.MuiPickersDay-today': {
                backgroundColor: 'transparent !important',
                boxShadow: 'none !important',
                color: '#D6A640 !important',
            }
        },

        '&.Mui-disabled': {
            color: '#9da6a2 !important',
            fontWeight: 500,
            boxShadow: 'none',
            backgroundColor: 'transparent',
            pointerEvents: 'none',
            '&.MuiPickersDay-today': {
                color: '#D6A640 !important',
            }
        }
    },

    '& .MuiPickersCalendarHeader-switchViewButton': { display: 'none' },
    '& .MuiDateCalendar-viewTransitionContainer': {
        padding: 0,
        overflow: 'hidden',
    },
    '& .MuiPickersSlideTransition-root.MuiDayCalendar-slideTransition': {
        minHeight: '147px',
        overflow: 'hidden',
        display: 'grid',
        '& > *': {
            gridColumn: 1,
            gridRow: 1,
        }
    },

    '@media (max-width: 400px)': {
        padding: '0',
        height: 'auto',
        minHeight: 'auto',
        '& .MuiDayCalendar-monthContainer': {
            gap: '2px',
        },
        '& .MuiPickersDay-root': {
            width: '28px !important',
            height: '28px !important',
            minWidth: '28px !important',
            fontSize: '11px',
        },
        '& .MuiDayCalendar-weekDayLabel': {
            width: '28px !important',
            height: '28px !important',
            fontSize: '9px',
        },
        '& .MuiPickersCalendarHeader-labelContainer': {
            fontSize: '12px',
        },
        '& .MuiPickersArrowSwitcher-button svg': {
            fontSize: '16px',
        }
    },
};
// export const CALENDAR_SX = {
//     width: '100%',
//     backgroundColor: 'transparent', 
//     border: 'none',
//     boxShadow: 'none',
//     padding: 0,
//     margin: 0,
//     height: 'auto',
//     fontFamily: '"Sora", sans-serif',
//     '& .MuiButtonBase-root-MuiPickersDay-root': {
//         color: 'red',
//     },
//     '& .MuiPickersCalendarHeader-root': {
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         padding: '0 8px',
//         margin: '0 0 14px 0',
//     },
//     '& .MuiPickersCalendarHeader-labelContainer': {
//         margin: 0,
//         fontSize: '15px', 
//         fontWeight: 700,
//         color: '#13231d', 
//         letterSpacing: '-.02em',
//     },
//     '& .MuiPickersArrowSwitcher-button': {
//         color: 'rgba(19, 35, 29, .46)',
//         '&:hover': { backgroundColor: 'transparent', color: '#13231d' },
//     },
//     '& .MuiDayCalendar-header': {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(7, 1fr)',
//         justifyContent: 'center',
//         marginBottom: '0px',
//         justifyItems: 'center',
//     },
//     '& .MuiDayCalendar-weekDayLabel': {
//         fontFamily: '"Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
//         fontSize: '12px',
//         fontWeight: 700,
//         padding: '4px 0',
//         color: '#13231d75',
//         height: '20px',
//     },
//     '& .MuiDayCalendar-weekHeader span': {
//         width: 'auto',
//         height: 'auto',
//         fontSize: '10px', 
//         fontWeight: 700,
//         color: 'rgba(19, 35, 29, .68)',
//         padding: '4px 0',
//         margin: 0,
//         fontFamily: '"Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
//     },
//     '& .MuiDayCalendar-monthContainer': {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '5px',
//     },
//     '& .MuiDayCalendar-weekContainer': {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(7, 1fr)',
//         justifyContent: 'center',
//         gap: '4px',
//         margin: '4px 0'
//     },
//     '& .MuiPickersDay-root': {
//         width: '36px',
//         height: '36px',
//         fontSize: '12px',
//         fontWeight: 700,
//         borderRadius: '12px', 
//         color: 'rgba(19, 35, 29, .68)',
//         backgroundColor: 'transparent',
//         border: '1px solid transparent',
//         transition: 'all 0.2s ease',

//         '&:hover': {
//             backgroundColor: 'rgba(19, 35, 29, 0.05)',
//         },


//         '&.Mui-selected': {
//             backgroundColor: 'transparent !important',
//             borderColor: 'rgba(19, 35, 29, 0.26) !important',
//             color: '#13231d !important',
//             fontWeight: 800,
//         },

//         '&.MuiPickersDay-dayOutsideMonth': {
//             color: 'rgba(19, 35, 29, .28)',
//         },
//     },

//     '& .MuiPickersCalendarHeader-switchViewButton': { display: 'none' },
//     '& .MuiDateCalendar-viewTransitionContainer': { 
//         padding: 0,
//     },

//     '& .MuiPickersDay-root.Mui-disabled:not(.Mui-selected)': {
//         color: '#13231dad',
//     },

//     '@media (max-width: 400px)': {
//         padding: '12px 10px 10px',
//         height: '15rem',
//         minHeight: '15rem',
//         '& .MuiDayCalendar-monthContainer': {
//             gap: '4px',
//         },
//         '& .MuiPickersDay-root': {
//             width: '28px',
//             height: '28px',
//             minWidth: '28px',
//             fontSize: '11px',
//         },
//         '& .MuiDayCalendar-weekDayLabel': {
//             width: '28px',
//             height: '28px',
//             fontSize: '9px',
//         },
//         '& .MuiPickersCalendarHeader-labelContainer': {
//             fontSize: '12px',
//         },
//         '& .MuiPickersArrowSwitcher-button svg': {
//             fontSize: '16px',
//         }
//     },
// };

export const TEXT_FIELD_SX = {
    backgroundColor: '#F8F6F2',
    borderRadius: '18px',
    border: '1px solid rgba(12, 36, 28, 0.08)',
    boxShadow: '0 8px 22px rgba(0,0,0,.02)',
    width: '100%',
    transition: 'all 0.2s ease',

    '&:hover': {
        borderColor: 'rgba(130, 177, 148, 0.5)',
    },

    '& .MuiOutlinedInput-root': {
        minHeight: '42px',
        height: '42px',
    },

    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '& .MuiSelect-select': {
        padding: '0 13px',
        display: 'flex',
        alignItems: 'center',
        fontSize: '11px',
        fontWeight: 600,
        color: 'rgba(19, 35, 29, .56)',
        fontFamily: '"Sora", sans-serif',
        textAlign: 'left',
        height: '100%',
    },

    '& .MuiInputLabel-root': {
        fontSize: '11px',
        color: 'rgba(19, 35, 29, 0.56)',
        fontWeight: 600,
        fontFamily: '"Sora", sans-serif',
        transform: 'translate(13px, 11px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            display: 'none',
        },
    },

    '& .Mui-disabled': {
        cursor: 'not-allowed',
        WebkitTextFillColor: 'rgba(19,35,29,.48)',
    }
};